var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: "col-lg-4 mx-auto" }, [
      _c("div", { staticClass: "auth-form-light text-left pr-5 pb-5 pl-5" }, [
        _c("div", { staticClass: "brand-logo text-right" }, [
          _c("img", {
            attrs: {
              src: "/media/aform-logo-black.png",
              alt: "Coachingclub.lu"
            }
          })
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("pages.login.title")))]),
        _vm._v(" "),
        _c("h6", { staticClass: "font-weight-light" }, [
          _vm._v(_vm._s(_vm.$t("pages.login.subtitle")))
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pt-3",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.login($event)
              }
            }
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$i18n.locale,
                      expression: "$i18n.locale"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.$i18n,
                        "locale",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "en" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("languages.english")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "de" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("languages.german")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "lb" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("languages.luxembourgish")) +
                        "\n                        "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                staticClass: "form-control form-control-lg",
                attrs: {
                  type: "email",
                  id: "email",
                  placeholder: _vm.$t("pages.login.email")
                },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  }
                ],
                staticClass: "form-control form-control-lg",
                attrs: {
                  type: "password",
                  id: "password",
                  placeholder: _vm.$t("pages.login.password")
                },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn"
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.login.sign_in")) +
                      "\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "my-2 d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "auth-link text-black",
                    attrs: { to: { name: "forgot-password" } }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("pages.login.forgot_password")) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "font-weight-light" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("pages.login.dont_have_an_account")) +
                        "\n                        "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "text-primary",
                        attrs: { to: { name: "register" } }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("pages.login.create_account")) +
                            "\n                        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-muted",
                    attrs: { tag: "a", to: { name: "terms-and-conditions" } }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("pages.login.t_and_c")) +
                        "\n                        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }